export enum PaymentErrorCode {
  PaymentNotPostedtoCCS = '750004',
}
